@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

.ClickableArea {
  @extend %font-family-primary;

  cursor: pointer;
  position: relative;

  .PlaceholderHide {
    display: none;
  }

  .SecondaryStyle {
    display: none;
  }

  &.cardBorderRadius {
    border-radius: 5px;
  }

  &:hover {
    .PlaceholderHide {
      display: block;
      position: absolute;
      background-color: $color-primary-black;
      opacity: 0.3;
      border-radius: inherit;
    }

    .SecondaryStyle {
      display: block;
      position: absolute;
      width: fit-content;
      padding: 7px 16px;
      background: $theme-color-background !important;
      border-radius: 6px;
      text-align: center;
      justify-items: center;
      align-content: center;
      left: 50%;
      top: 50%;
      transform: translate(-50%,-50%);
    }
  }
}
